import React from "react"
import { gridRowStyle, gridItemStyle } from "../styles/commonStyles"

const GridRow = ({ children, style = {}, className = "", columns = 2 }) => {
	const gridStyle = {
		...gridRowStyle,
		gridTemplateColumns: columns === 1 ? "1fr" : `repeat(${columns}, 1fr)`,
		...style,
	}

	return (
		<div className={`grid-row ${className}`} style={gridStyle}>
			{children}
		</div>
	)
}

const GridItem = ({ children, style = {}, className = "", span = 1 }) => {
	const itemStyle = {
		...gridItemStyle,
		gridColumn: span > 1 ? `span ${span}` : "auto",
		...style,
	}

	return (
		<div className={className} style={itemStyle}>
			{children}
		</div>
	)
}

// Grid Container Component
const GridContainer = ({ children, gap = "12px 24px", style = {} }) => {
	return (
		<div
			style={{
				display: "grid",
				gap,
				...style,
			}}
		>
			{children}
		</div>
	)
}

export { GridRow, GridItem, GridContainer }
